import { useCurrentSiteId } from 'contexts/SiteConfig'
import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query'
import { CheckAvailabilityApi } from '@trybeapp/sdk.shop'

const api = new CheckAvailabilityApi()

export const useAppointmentSlots = (
  { appointmentTypeId = '', ...params }: any = {},
  options: UseQueryOptions = {}
): UseQueryResult<any> => {
  const siteId = useCurrentSiteId()
  const { enabled = true } = options
  options.cacheTime = options.cacheTime ?? 0

  return useQuery(
    ['appointmentSlots', { appointmentTypeId, siteId, ...params }],
    () => api.getAppointmentAvailableSlots(siteId, appointmentTypeId, params),
    { ...options, enabled: !!appointmentTypeId && enabled }
  )
}
